module.exports = __webpack_public_path__ + "static/img/career-course-rssy.72c03893.png";